var _line, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMegaphoneOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.36603,
    y1: 3.36603,
    x2: 15.866,
    y2: 19.8205,
    stroke: "url(#paint0_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88819 8.00249C5.28314 8.0613 4 9.38102 4 11.0004C4 12.3134 4.84347 13.4294 6.01811 13.8361C6.54 14.0168 7 14.4482 7 15.0004V18.0004C7 18.5527 7.44772 19.0004 8 19.0004C8.55228 19.0004 9 18.5527 9 18.0004V14.6185C9 13.9895 9.56008 13.5465 10.1352 13.6265L6.88819 8.00249ZM16.3158 16.3317C16.7011 16.2021 17 15.8419 17 15.3824V13.5004C17 13.2243 17.2273 13.0069 17.4949 12.9387C18.3601 12.7185 19 11.9342 19 11.0004C19 10.0667 18.3601 9.28241 17.4949 9.06216C17.2273 8.99403 17 8.77659 17 8.50044V6.61848C17 5.8751 16.2177 5.3916 15.5528 5.72405L11.3925 7.80419L16.3158 16.3317Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5,
    y1: 3,
    x2: 9.31576,
    y2: 22.8432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6867FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 4,
    y1: 5.61719,
    x2: 19.2239,
    y2: 5.87696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6867FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneOff);
export default __webpack_public_path__ + "static/media/megaphoneOff.256f93388007988f383b3c9ed0de615c.svg";
export { ForwardRef as ReactComponent };